import { render } from "./flow-mgmt.vue?vue&type=template&id=5482d856&scoped=true"
import script from "./flow-mgmt.vue?vue&type=script&lang=js"
export * from "./flow-mgmt.vue?vue&type=script&lang=js"

import "./flow-mgmt.vue?vue&type=style&index=0&id=5482d856&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5482d856"]])

export default __exports__